import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { AuthenticationService } from '../../services/authentication_service';

export const roleGuard: CanActivateFn = (route) => {
  const roles = route.data['roles'] as readonly string[] | undefined;
  const authService = inject(AuthenticationService);
  const router = inject(Router);
  if (!roles || authService.hasRole(roles)) {
    return true;
  }
  return router.createUrlTree(['/dashboard']);
};
